// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  ServiceTokenEvent,
} from "./types";


export default __t.row({
  id: __t.u64().primaryKey(),
  tokenId: __t.u32().name("token_id"),
  get event() {
    return ServiceTokenEvent;
  },
  actor: __t.identity(),
  detail: __t.string(),
  occurredAt: __t.timestamp().name("occurred_at"),
});
